(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["df-mobile-buy"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('df-mobile-buy')){
  customElements.define('df-mobile-buy',class extends HTMLElement{
    connectedCallback(){
      this.variants=JSON.parse(this.querySelector('[data-df-variants]').textContent);
      this.mobile=matchMedia('(max-width:749px)');
      this.section=document.querySelector('[data-section-type="product"][data-section-id="'+this.dataset.sectionId+'"]');
      if(!this.section)return;
      this.update=()=>{
        const form=this.section.querySelector('[data-product-form]');
        const main=form?.querySelector('[data-add-to-cart]');
        const input=form?.querySelector('[name="id"]');
        const variant=this.variants.find(item=>String(item.id)===input?.value);
        if(!main)return;
        this.querySelector('[data-df-variant]').textContent=variant?.title==='Default Title'?this.section.querySelector('h1')?.textContent.trim():variant?.title||'';
        this.querySelector('[data-df-price]').textContent=main.querySelector('[data-button-price]')?.textContent.trim()||'';
        const button=this.querySelector('[data-df-buy]');
        button.textContent=main.querySelector('[data-add-to-cart-text]')?.textContent.trim()||main.getAttribute('aria-label');
        button.disabled=main.disabled||main.classList.contains('loading');
        const cookie=document.querySelector('#shopify-pc__banner');
        const cookieOpen=cookie&&getComputedStyle(cookie).display!=='none';
        const drawerOpen=document.body.className.includes('drawer-open')||document.querySelector('.drawer.is-open,.drawer--is-open,.drawer--visible');
        const chatOpen=document.querySelector('shopify-chat')?.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('[part~="dialog"][aria-modal="true"]');
        const visible=this.mobile.matches&&main.getBoundingClientRect().bottom<0&&!cookieOpen&&!drawerOpen&&!chatOpen;
        this.hidden=!visible;
        document.body.classList.toggle('df-mobile-buy-visible',visible);
        if(document.querySelector('#PBarNextFrame')){
          this.style.setProperty('--df-preview-offset','64px');
          document.body.style.setProperty('--df-preview-offset','64px');
        }
      };
      this.onClick=()=>{
        const main=this.section.querySelector('[data-product-form] [data-add-to-cart]');
        if(main&&!main.disabled)main.click();
      };
      this.querySelector('[data-df-buy]').addEventListener('click',this.onClick);
      this.observer=new MutationObserver(this.update);
      this.observer.observe(this.section.querySelector('.product__main__content'),{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','value','aria-busy'],characterData:true});
      this.bodyObserver=new MutationObserver(this.update);
      this.bodyObserver.observe(document.body,{attributes:true,attributeFilter:['class']});
      this.overlayObserver=new MutationObserver(this.update);
      document.querySelectorAll('.drawer').forEach(drawer=>this.overlayObserver.observe(drawer,{attributes:true,attributeFilter:['class']}));
      this.onDocumentClick=()=>requestAnimationFrame(this.update);
      document.addEventListener('click',this.onDocumentClick);
      window.addEventListener('scroll',this.update,{passive:true});
      window.addEventListener('resize',this.update);
      this.section.addEventListener('change',this.update);
      this.update();
    }
    disconnectedCallback(){
      this.observer?.disconnect();this.bodyObserver?.disconnect();this.overlayObserver?.disconnect();
      window.removeEventListener('scroll',this.update);window.removeEventListener('resize',this.update);
      this.section?.removeEventListener('change',this.update);
      document.removeEventListener('click',this.onDocumentClick);
      document.body.classList.remove('df-mobile-buy-visible');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["df-review-highlight"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('df-review-highlight')){
  customElements.define('df-review-highlight',class extends HTMLElement{
    connectedCallback(){
      let tries=0;
      const populate=()=>{
        const data=window.jdgm?.data?.reviewWidget?.[this.dataset.productId];
        const review=data?.reviews?.find(item=>item.verified_buyer===true&&Number(item.rating)>=4&&item.body&&item.reviewer_name&&!item.is_anonymous_reviewer);
        if(review){
          this.querySelector('[data-df-review-quote]').textContent=review.body;
          this.querySelector('[data-df-review-author]').textContent=review.reviewer_name;
          this.hidden=false;
          clearInterval(this.timer);
        }else if(++tries>=30)clearInterval(this.timer);
      };
      this.timer=setInterval(populate,1000);
      populate();
    }
    disconnectedCallback(){clearInterval(this.timer);}
  });
}
  } catch(e) { console.error(e); }
})();

})();
